import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2f08bc40&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=2f08bc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08bc40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f08bc40')) {
      api.createRecord('2f08bc40', component.options)
    } else {
      api.reload('2f08bc40', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2f08bc40&scoped=true&", function () {
      api.rerender('2f08bc40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G6Ie01j45s70/JS/comp/SearchFilterTokens.vue"
export default component.exports